export default __webpack_public_path__ + "e05c5f3d1fa6a3893d84c1eef4e89951.ttf";